"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: insights/insights-data.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Finsights%2Finsights-data.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.MerchantMetric = exports.SpendingPersonality = exports.AmountMetric = exports.CountMetric = exports.UserInsights = void 0;
const amount_1 = require("../common/amount");
const dayofweek_1 = require("../google/type/dayofweek");
const insights_enum_1 = require("./insights-enum");
const protobufPackage = 'com.step.insights.proto';
function createBaseUserInsights() {
    return {
        purchaseCount: undefined,
        highestSpendingDay: dayofweek_1.DayOfWeek.DAY_OF_WEEK_UNSPECIFIED,
        referralCount: undefined,
        spendingPersonality: undefined,
        offerCount: undefined,
        p2pSent: undefined,
        p2pReceived: undefined,
        savingsGoalsCreated: undefined,
        savingsGoalsAchieved: undefined,
        startDateMs: '0',
        endDateMs: '0',
        initialCreditScore: undefined,
        finalCreditScore: undefined,
        amountSaved: undefined,
        interestEarned: undefined,
        savingsRoundUps: undefined,
        investingRoundUps: undefined,
        topMerchants: [],
        pointsEarned: undefined,
        triviaScoreTotal: undefined,
        triviaHighestStreak: undefined,
    };
}
exports.UserInsights = {
    fromJSON(object) {
        const message = {
            startDateMs: isSet(object.startDateMs) ? globalThis.String(object.startDateMs) : '0',
            endDateMs: isSet(object.endDateMs) ? globalThis.String(object.endDateMs) : '0',
        };
        if (isSet(object.purchaseCount)) {
            message.purchaseCount = exports.CountMetric.fromJSON(object.purchaseCount);
        }
        if (isSet(object.highestSpendingDay)) {
            message.highestSpendingDay = (0, dayofweek_1.dayOfWeekFromJSON)(object.highestSpendingDay);
        }
        if (isSet(object.referralCount)) {
            message.referralCount = exports.CountMetric.fromJSON(object.referralCount);
        }
        if (isSet(object.spendingPersonality)) {
            message.spendingPersonality = exports.SpendingPersonality.fromJSON(object.spendingPersonality);
        }
        if (isSet(object.offerCount)) {
            message.offerCount = exports.CountMetric.fromJSON(object.offerCount);
        }
        if (isSet(object.p2pSent)) {
            message.p2pSent = exports.AmountMetric.fromJSON(object.p2pSent);
        }
        if (isSet(object.p2pReceived)) {
            message.p2pReceived = exports.AmountMetric.fromJSON(object.p2pReceived);
        }
        if (isSet(object.savingsGoalsCreated)) {
            message.savingsGoalsCreated = exports.CountMetric.fromJSON(object.savingsGoalsCreated);
        }
        if (isSet(object.savingsGoalsAchieved)) {
            message.savingsGoalsAchieved = exports.CountMetric.fromJSON(object.savingsGoalsAchieved);
        }
        if (isSet(object.initialCreditScore)) {
            message.initialCreditScore = exports.CountMetric.fromJSON(object.initialCreditScore);
        }
        if (isSet(object.finalCreditScore)) {
            message.finalCreditScore = exports.CountMetric.fromJSON(object.finalCreditScore);
        }
        if (isSet(object.amountSaved)) {
            message.amountSaved = exports.AmountMetric.fromJSON(object.amountSaved);
        }
        if (isSet(object.interestEarned)) {
            message.interestEarned = exports.AmountMetric.fromJSON(object.interestEarned);
        }
        if (isSet(object.savingsRoundUps)) {
            message.savingsRoundUps = exports.AmountMetric.fromJSON(object.savingsRoundUps);
        }
        if (isSet(object.investingRoundUps)) {
            message.investingRoundUps = exports.AmountMetric.fromJSON(object.investingRoundUps);
        }
        if (globalThis.Array.isArray(object?.topMerchants)) {
            message.topMerchants = object.topMerchants.map((e) => exports.MerchantMetric.fromJSON(e));
        }
        if (isSet(object.pointsEarned)) {
            message.pointsEarned = exports.AmountMetric.fromJSON(object.pointsEarned);
        }
        if (isSet(object.triviaScoreTotal)) {
            message.triviaScoreTotal = exports.CountMetric.fromJSON(object.triviaScoreTotal);
        }
        if (isSet(object.triviaHighestStreak)) {
            message.triviaHighestStreak = exports.CountMetric.fromJSON(object.triviaHighestStreak);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.purchaseCount !== undefined) {
            obj.purchaseCount = exports.CountMetric.toJSON(message.purchaseCount);
        }
        if (message.highestSpendingDay !== undefined &&
            message.highestSpendingDay !== dayofweek_1.DayOfWeek.DAY_OF_WEEK_UNSPECIFIED) {
            obj.highestSpendingDay = (0, dayofweek_1.dayOfWeekToJSON)(message.highestSpendingDay);
        }
        if (message.referralCount !== undefined) {
            obj.referralCount = exports.CountMetric.toJSON(message.referralCount);
        }
        if (message.spendingPersonality !== undefined) {
            obj.spendingPersonality = exports.SpendingPersonality.toJSON(message.spendingPersonality);
        }
        if (message.offerCount !== undefined) {
            obj.offerCount = exports.CountMetric.toJSON(message.offerCount);
        }
        if (message.p2pSent !== undefined) {
            obj.p2pSent = exports.AmountMetric.toJSON(message.p2pSent);
        }
        if (message.p2pReceived !== undefined) {
            obj.p2pReceived = exports.AmountMetric.toJSON(message.p2pReceived);
        }
        if (message.savingsGoalsCreated !== undefined) {
            obj.savingsGoalsCreated = exports.CountMetric.toJSON(message.savingsGoalsCreated);
        }
        if (message.savingsGoalsAchieved !== undefined) {
            obj.savingsGoalsAchieved = exports.CountMetric.toJSON(message.savingsGoalsAchieved);
        }
        if (message.startDateMs !== '0') {
            obj.startDateMs = message.startDateMs;
        }
        if (message.endDateMs !== '0') {
            obj.endDateMs = message.endDateMs;
        }
        if (message.initialCreditScore !== undefined) {
            obj.initialCreditScore = exports.CountMetric.toJSON(message.initialCreditScore);
        }
        if (message.finalCreditScore !== undefined) {
            obj.finalCreditScore = exports.CountMetric.toJSON(message.finalCreditScore);
        }
        if (message.amountSaved !== undefined) {
            obj.amountSaved = exports.AmountMetric.toJSON(message.amountSaved);
        }
        if (message.interestEarned !== undefined) {
            obj.interestEarned = exports.AmountMetric.toJSON(message.interestEarned);
        }
        if (message.savingsRoundUps !== undefined) {
            obj.savingsRoundUps = exports.AmountMetric.toJSON(message.savingsRoundUps);
        }
        if (message.investingRoundUps !== undefined) {
            obj.investingRoundUps = exports.AmountMetric.toJSON(message.investingRoundUps);
        }
        if (message.topMerchants?.length) {
            obj.topMerchants = message.topMerchants.map((e) => exports.MerchantMetric.toJSON(e));
        }
        if (message.pointsEarned !== undefined) {
            obj.pointsEarned = exports.AmountMetric.toJSON(message.pointsEarned);
        }
        if (message.triviaScoreTotal !== undefined) {
            obj.triviaScoreTotal = exports.CountMetric.toJSON(message.triviaScoreTotal);
        }
        if (message.triviaHighestStreak !== undefined) {
            obj.triviaHighestStreak = exports.CountMetric.toJSON(message.triviaHighestStreak);
        }
        return obj;
    },
    create(base) {
        return exports.UserInsights.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUserInsights();
        message.purchaseCount = (object.purchaseCount !== undefined && object.purchaseCount !== null)
            ? exports.CountMetric.fromPartial(object.purchaseCount)
            : undefined;
        message.highestSpendingDay = object.highestSpendingDay ?? dayofweek_1.DayOfWeek.DAY_OF_WEEK_UNSPECIFIED;
        message.referralCount = (object.referralCount !== undefined && object.referralCount !== null)
            ? exports.CountMetric.fromPartial(object.referralCount)
            : undefined;
        message.spendingPersonality =
            (object.spendingPersonality !== undefined && object.spendingPersonality !== null)
                ? exports.SpendingPersonality.fromPartial(object.spendingPersonality)
                : undefined;
        message.offerCount = (object.offerCount !== undefined && object.offerCount !== null)
            ? exports.CountMetric.fromPartial(object.offerCount)
            : undefined;
        message.p2pSent = (object.p2pSent !== undefined && object.p2pSent !== null)
            ? exports.AmountMetric.fromPartial(object.p2pSent)
            : undefined;
        message.p2pReceived = (object.p2pReceived !== undefined && object.p2pReceived !== null)
            ? exports.AmountMetric.fromPartial(object.p2pReceived)
            : undefined;
        message.savingsGoalsCreated =
            (object.savingsGoalsCreated !== undefined && object.savingsGoalsCreated !== null)
                ? exports.CountMetric.fromPartial(object.savingsGoalsCreated)
                : undefined;
        message.savingsGoalsAchieved =
            (object.savingsGoalsAchieved !== undefined && object.savingsGoalsAchieved !== null)
                ? exports.CountMetric.fromPartial(object.savingsGoalsAchieved)
                : undefined;
        message.startDateMs = object.startDateMs ?? '0';
        message.endDateMs = object.endDateMs ?? '0';
        message.initialCreditScore =
            (object.initialCreditScore !== undefined && object.initialCreditScore !== null)
                ? exports.CountMetric.fromPartial(object.initialCreditScore)
                : undefined;
        message.finalCreditScore =
            (object.finalCreditScore !== undefined && object.finalCreditScore !== null)
                ? exports.CountMetric.fromPartial(object.finalCreditScore)
                : undefined;
        message.amountSaved = (object.amountSaved !== undefined && object.amountSaved !== null)
            ? exports.AmountMetric.fromPartial(object.amountSaved)
            : undefined;
        message.interestEarned = (object.interestEarned !== undefined && object.interestEarned !== null)
            ? exports.AmountMetric.fromPartial(object.interestEarned)
            : undefined;
        message.savingsRoundUps =
            (object.savingsRoundUps !== undefined && object.savingsRoundUps !== null)
                ? exports.AmountMetric.fromPartial(object.savingsRoundUps)
                : undefined;
        message.investingRoundUps =
            (object.investingRoundUps !== undefined && object.investingRoundUps !== null)
                ? exports.AmountMetric.fromPartial(object.investingRoundUps)
                : undefined;
        message.topMerchants = object.topMerchants?.map((e) => exports.MerchantMetric.fromPartial(e)) || [];
        message.pointsEarned = (object.pointsEarned !== undefined && object.pointsEarned !== null)
            ? exports.AmountMetric.fromPartial(object.pointsEarned)
            : undefined;
        message.triviaScoreTotal =
            (object.triviaScoreTotal !== undefined && object.triviaScoreTotal !== null)
                ? exports.CountMetric.fromPartial(object.triviaScoreTotal)
                : undefined;
        message.triviaHighestStreak =
            (object.triviaHighestStreak !== undefined && object.triviaHighestStreak !== null)
                ? exports.CountMetric.fromPartial(object.triviaHighestStreak)
                : undefined;
        return message;
    },
};
function createBaseCountMetric() {
    return { count: 0, percentile: 0 };
}
exports.CountMetric = {
    fromJSON(object) {
        const message = {
            count: isSet(object.count) ? globalThis.Number(object.count) : 0,
            percentile: isSet(object.percentile) ? globalThis.Number(object.percentile) : 0,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.count !== 0) {
            obj.count = message.count;
        }
        if (message.percentile !== 0) {
            obj.percentile = message.percentile;
        }
        return obj;
    },
    create(base) {
        return exports.CountMetric.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCountMetric();
        message.count = object.count ?? 0;
        message.percentile = object.percentile ?? 0;
        return message;
    },
};
function createBaseAmountMetric() {
    return { amount: amount_1.Amount.fromPartial({}), percentile: 0 };
}
exports.AmountMetric = {
    fromJSON(object) {
        const message = {
            amount: isSet(object.amount) ? amount_1.Amount.fromJSON(object.amount) : amount_1.Amount.fromPartial({}),
            percentile: isSet(object.percentile) ? globalThis.Number(object.percentile) : 0,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.amount !== undefined) {
            obj.amount = amount_1.Amount.toJSON(message.amount);
        }
        if (message.percentile !== 0) {
            obj.percentile = message.percentile;
        }
        return obj;
    },
    create(base) {
        return exports.AmountMetric.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAmountMetric();
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? amount_1.Amount.fromPartial(object.amount)
            : amount_1.Amount.fromPartial({});
        message.percentile = object.percentile ?? 0;
        return message;
    },
};
function createBaseSpendingPersonality() {
    return { personality: insights_enum_1.Personality.INVALID_PERSONALITY, title: '', description: '' };
}
exports.SpendingPersonality = {
    fromJSON(object) {
        const message = {
            personality: isSet(object.personality)
                ? (0, insights_enum_1.personalityFromJSON)(object.personality)
                : insights_enum_1.Personality.INVALID_PERSONALITY,
            title: isSet(object.title) ? globalThis.String(object.title) : '',
        };
        if (isSet(object.description)) {
            message.description = globalThis.String(object.description);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.personality !== insights_enum_1.Personality.INVALID_PERSONALITY) {
            obj.personality = (0, insights_enum_1.personalityToJSON)(message.personality);
        }
        if (message.title !== '') {
            obj.title = message.title;
        }
        if (message.description !== undefined && message.description !== '') {
            obj.description = message.description;
        }
        return obj;
    },
    create(base) {
        return exports.SpendingPersonality.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSpendingPersonality();
        message.personality = object.personality ?? insights_enum_1.Personality.INVALID_PERSONALITY;
        message.title = object.title ?? '';
        message.description = object.description ?? '';
        return message;
    },
};
function createBaseMerchantMetric() {
    return { name: '', purchaseCount: undefined, logoUrl: '' };
}
exports.MerchantMetric = {
    fromJSON(object) {
        const message = {
            name: isSet(object.name) ? globalThis.String(object.name) : '',
        };
        if (isSet(object.purchaseCount)) {
            message.purchaseCount = exports.CountMetric.fromJSON(object.purchaseCount);
        }
        if (isSet(object.logoUrl)) {
            message.logoUrl = globalThis.String(object.logoUrl);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.name !== '') {
            obj.name = message.name;
        }
        if (message.purchaseCount !== undefined) {
            obj.purchaseCount = exports.CountMetric.toJSON(message.purchaseCount);
        }
        if (message.logoUrl !== undefined && message.logoUrl !== '') {
            obj.logoUrl = message.logoUrl;
        }
        return obj;
    },
    create(base) {
        return exports.MerchantMetric.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseMerchantMetric();
        message.name = object.name ?? '';
        message.purchaseCount = (object.purchaseCount !== undefined && object.purchaseCount !== null)
            ? exports.CountMetric.fromPartial(object.purchaseCount)
            : undefined;
        message.logoUrl = object.logoUrl ?? '';
        return message;
    },
};
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=insights-data.js.map